import {ErrorHandler, Injectable, NgZone} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {ErrorDialogComponent} from './error-dialog/error-dialog.component';
import {BusinessError} from './utils';

export const lookupErrorMessage = (error: any): string => {
    if (typeof error === 'string') {
        return error;
    }
    if (typeof error !== 'object') {
        return JSON.stringify(error);
    }
    if (!!error.error) {
        return lookupErrorMessage(error.error);
    }
    if (!!error.sqlerrm) {
        return lookupErrorMessage(error.sqlerrm);
    }
    return JSON.stringify(error);
};

@Injectable()
export class AppErrorHandler implements ErrorHandler {


    constructor(private zone: NgZone,
                public dialog: MatDialog) {
    }

    handleError(rawError: any) {
        console.log(rawError);
        if (rawError === null) {
            return;
        }
        let message: string;
        let title: string;
        let type: string;
        const error = rawError.hasOwnProperty('rejection') ? rawError.rejection : rawError;
        if (error instanceof BusinessError) {
            title = 'Error';
            type = 'business';
            message = error.message;
        } else if (error instanceof HttpErrorResponse) {
            title = error.statusText;
            message = lookupErrorMessage(error);
        } else if (error instanceof Error) {
            title = 'Unexpected Error';
            message = error.message;
        }
        this.showError(title, message, type);
        throw null; // a trick to prevent infinity loop when pipe error
    }

    showError(title, message, type) {
        this.zone.run(() => this.dialog.open(ErrorDialogComponent, {
            data: {title, message, type},
            disableClose: true
        }));
    }

}
